import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-hkbkplacements-create',
  templateUrl: './hkbkplacements-create.component.html',
  styleUrls: ['./hkbkplacements-create.component.scss']
})
export class HkbkplacementsCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      console.log(`${id}`);
      /* this.http.get<any>(this.api_endpoint+'/placementsoverviewbyid/' + `${id}`).subscribe(
        data => {
          console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              heading: data.data.heading,
              title: data.data.title,
              description: data.data.description,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      }); */
    });

    this.http.get<any>(this.api_endpoint+'/placementsoverviewfindone/').subscribe(
      data => {
        console.log(data.data);
        if(data.data != null){
          this.action = 'Update';
          this.Form.patchValue({
            _id: data.data._id,
            heading: data.data.heading,
            image: data.data.image,
            title: data.data.title,
            description: data.data.description,
            heading1: data.data.heading1,
            title1: data.data.title1,
            heading2: data.data.heading2,
            title2: data.data.title2,
            heading3: data.data.heading3,
            title3: data.data.title3,
            heading4: data.data.heading4,
            title4: data.data.title4,
            heading5: data.data.heading5,
            title5: data.data.title5,
            heading6: data.data.heading6,
            title6: data.data.title6,
            heading7: data.data.heading7,
            title7: data.data.title7,
            heading8: data.data.heading8,
            title8: data.data.title8,
            heading9: data.data.heading9,
            title9: data.data.title9,
            seohidden: data.data.seohidden
          });
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });

    this.Form = this.formBuilder.group({
      heading: ['', Validators.required],
      image: ['', Validators.required],
      title: [''],
      description: ['', Validators.required],
      heading1: ['', Validators.required],
      title1: ['', Validators.required],
      heading2: ['', Validators.required],
      title2: ['', Validators.required],
      heading3: ['', Validators.required],
      title3: ['', Validators.required],
      heading4: ['', Validators.required],
      title4: ['', Validators.required],
      heading5: ['', Validators.required],
      title5: ['', Validators.required],
      heading6: ['', Validators.required],
      title6: ['', Validators.required],
      heading7: ['', Validators.required],
      title7: ['', Validators.required],
      heading8: ['', Validators.required],
      title8: ['', Validators.required],
      heading9: ['', Validators.required],
      title9: ['', Validators.required],
      seohidden: [''],
      _id: ['']
    })

  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "heading" : this.Form.value.heading,
      "image" : this.Form.value.image,
      "title" : this.Form.value.title,
      "description" : this.Form.value.description,
      "heading1" : this.Form.value.heading1,
      "title1" : this.Form.value.title1,
      "heading2" : this.Form.value.heading2,
      "title2" : this.Form.value.title2,
      "heading3" : this.Form.value.heading3,
      "title3" : this.Form.value.title3,
      "heading4" : this.Form.value.heading4,
      "title4" : this.Form.value.title4,
      "heading5" : this.Form.value.heading5,
      "title5" : this.Form.value.title5,
      "heading6" : this.Form.value.heading6,
      "title6" : this.Form.value.title6,
      "heading7" : this.Form.value.heading7,
      "title7" : this.Form.value.title7,
      "heading8" : this.Form.value.heading8,
      "title8" : this.Form.value.title8,
      "heading9" : this.Form.value.heading9,
      "title9" : this.Form.value.title9,
      "admin" : sessionStorage.getItem('adminName'),
      "seohidden": this.Form.value.seohidden
    };
    console.log(data);
    this.http.post<any>(this.api_endpoint+'/placementsoverview', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        // this.router.navigateByUrl('/adminhkbkcms/placements-overview/list-page');
        window.location.reload();
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "heading" : this.Form.value.heading,
      "image" : this.Form.value.image,
      "title" : this.Form.value.title,
      "description" : this.Form.value.description,
      "heading1" : this.Form.value.heading1,
      "title1" : this.Form.value.title1,
      "heading2" : this.Form.value.heading2,
      "title2" : this.Form.value.title2,
      "heading3" : this.Form.value.heading3,
      "title3" : this.Form.value.title3,
      "heading4" : this.Form.value.heading4,
      "title4" : this.Form.value.title4,
      "heading5" : this.Form.value.heading5,
      "title5" : this.Form.value.title5,
      "heading6" : this.Form.value.heading6,
      "title6" : this.Form.value.title6,
      "heading7" : this.Form.value.heading7,
      "title7" : this.Form.value.title7,
      "heading8" : this.Form.value.heading8,
      "title8" : this.Form.value.title8,
      "heading9" : this.Form.value.heading9,
      "title9" : this.Form.value.title9,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.Form.value._id,
      "seohidden": this.Form.value.seohidden
    };
      console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/placementsoverview/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        // this.router.navigateByUrl('/adminhkbkcms/placements-overview/list-page');
        window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
